module.exports = __webpack_public_path__ + "img/change-language.8d7afc0a.png";